// extracted by mini-css-extract-plugin
export var activeDot = "_5f-c";
export var buttonContainer = "_5f-9";
export var channelButton = "_5f-a";
export var clickable = "_5f-d";
export var content = "_5f-0";
export var contentFull = "_5f-2";
export var contentThird = "_5f-1";
export var contentWrapper = "_5f-7";
export var description = "_5f-5";
export var heightShort = "_5f-f";
export var image = "_5f-3";
export var imageContainer = "_5f-4";
export var selectButton = "_5f-e";
export var spinnerContainer = "_5f-b";
export var titleContent = "_5f-8";
export var titleWrapper = "_5f-6";